import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

import { FlexRow, HelperBlock } from 'components/Shared/Scaffolding';
import { HelpButton } from 'components/Shared/Buttons';
import { SCAFFOLDING, SETTINGS_GROUP, SETTINGS_INPUTS } from 'theme';

const propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    description: null,
    children: null,
};

const SettingsLabel = styled.span`
    font-weight: 700;
    text-transform: uppercase;
`;

const SettingsContent = styled.div`
    margin-top: 4px;
    margin-left: -${SETTINGS_GROUP.PADDING.X};
    margin-right: -${SETTINGS_GROUP.PADDING.X};
    padding: ${SETTINGS_GROUP.PADDING.Y} ${SETTINGS_GROUP.PADDING.X};
    background-color: ${SETTINGS_GROUP.BG.BASE};

    ${ifProp(
        'spacing',
        css`
            > * + * {
                margin-top: ${prop('spacing')};
            }
        `
    )};
`;

const SettingsContentHR = styled.hr`
    margin-left: -${SETTINGS_GROUP.PADDING.X};
    margin-right: -${SETTINGS_GROUP.PADDING.X};
    border-top: 1px solid #fff;
`;

const SettingsSubGroup = styled.div`
    margin-left: -${SETTINGS_INPUTS.PADDING.X};
    margin-right: -${SETTINGS_INPUTS.PADDING.X};
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SETTINGS_INPUTS.PADDING.X};
    background-color: ${SETTINGS_INPUTS.BG.SUB};

    & + & {
        margin-top: 1px;
    }

    *:not(&) + & {
        margin-top: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    }

    &:last-child {
        margin-bottom: -${SETTINGS_GROUP.PADDING.Y};
    }

    ${ifProp(
        'collapsible',
        css`
            padding: 0;

            .ReactCollapse--content {
                padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SCAFFOLDING.GUTTER};
            }
        `
    )}
`;

const SettingsHelper = styled(HelperBlock)`
    & + *,
    * + & {
        margin-top: ${SETTINGS_GROUP.PADDING.Y};
    }

    ${ifProp(
        'highlight',
        css`
            margin-left: -${SETTINGS_GROUP.PADDING.X};
            margin-right: -${SETTINGS_GROUP.PADDING.X};
        `
    )}
`;

const SettingsGroup = ({ name, description, labelClassName, contentClassName, children, spacing, ...props }) => {
    return (
        <div {...props}>
            <FlexRow alignCenter className={labelClassName} spacing={SCAFFOLDING.GUTTER_FACTOR(0.25)}>
                <SettingsLabel>{name}</SettingsLabel>
                <HelpButton value={description} />
            </FlexRow>
            <SettingsContent className={contentClassName} spacing={spacing}>
                {children}
            </SettingsContent>
        </div>
    );
};

SettingsGroup.propTypes = propTypes;
SettingsGroup.defaultProps = defaultProps;

export default SettingsGroup;
export { SettingsContentHR, SettingsSubGroup, SettingsHelper };
